import {UniversalCard} from '../Cards/UniversalCard';
import {UserForm} from '../Form/UserForm';
import React from 'react';
import {CreateUserInput} from '../../graphql';

interface UserNewViewProps {
  createUser: Function;
}

export const UserNewView = ({createUser}: UserNewViewProps) => {
  return (
    <UniversalCard title="New User">
      <UserForm onSubmit={(values: CreateUserInput) => createUser(values)}/>
    </UniversalCard>
  );
};
